import { WEATHER_ICONS, TEMPERATURE_UNITS } from '../constants';

/**
 * UI Service
 * Handles all UI-related utility functions
 */

/**
 * Get weather icon for condition
 * @param {string} condition - The weather condition
 * @returns {string} - Weather emoji
 */
export const getWeatherIcon = (condition) => {
  return WEATHER_ICONS[condition] || '🌡️';
};

/**
 * Convert Celsius to Fahrenheit
 * @param {number} celsius - Temperature in Celsius
 * @returns {number} - Temperature in Fahrenheit
 */
export const celsiusToFahrenheit = (celsius) => {
  return Math.round((celsius * 9/5) + 32);
};

/**
 * Format temperature with unit
 * @param {number} temp - Temperature value
 * @param {string} unit - Unit (C or F)
 * @returns {string} - Formatted temperature
 */
export const formatTemperature = (temp, unit = TEMPERATURE_UNITS.CELSIUS) => {
  if (unit === TEMPERATURE_UNITS.FAHRENHEIT) {
    return `${celsiusToFahrenheit(temp)}°F`;
  }
  return `${temp}°${unit}`;
};

/**
 * Get wind direction full name
 * @param {string} direction - Wind direction abbreviation
 * @returns {string} - Full wind direction name
 */
export const getWindDirectionName = (direction) => {
  const windDirections = {
    'N': 'North', 'NNE': 'North-Northeast', 'NE': 'Northeast',
    'ENE': 'East-Northeast', 'E': 'East', 'ESE': 'East-Southeast',
    'SE': 'Southeast', 'SSE': 'South-Southeast', 'S': 'South',
    'SSW': 'South-Southwest', 'SW': 'Southwest', 'WSW': 'West-Southwest',
    'W': 'West', 'WNW': 'West-Northwest', 'NW': 'Northwest',
    'NNW': 'North-Northwest'
  };
  return windDirections[direction] || direction;
};
  